var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name=='Login')?_c('div'):(_vm.$route.name=='POS')?_c('div'):_c('div',[_c('ToolTop'),_c('MenuBar'),_c('Breadcrumbs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }